import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'jobs',
  components: {
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({ jobs: 'getJobs' }),
  },
  methods: {
    ...mapActions(['addJob', 'bindJobs']),
  },
  created() {
    this.bindJobs();
  },
};
